__turbopack_context__.v({
  "checkBadgeBase": "index-module-scss-module__uj3OjW__checkBadgeBase",
  "error": "index-module-scss-module__uj3OjW__error",
  "hint": "index-module-scss-module__uj3OjW__hint",
  "infoBody": "index-module-scss-module__uj3OjW__infoBody",
  "infoCard": "index-module-scss-module__uj3OjW__infoCard",
  "infoDesc": "index-module-scss-module__uj3OjW__infoDesc",
  "infoIcon": "index-module-scss-module__uj3OjW__infoIcon",
  "infoTitle": "index-module-scss-module__uj3OjW__infoTitle",
  "infoTop": "index-module-scss-module__uj3OjW__infoTop",
  "link": "index-module-scss-module__uj3OjW__link",
  "optionCard": "index-module-scss-module__uj3OjW__optionCard",
  "optionIcon": "index-module-scss-module__uj3OjW__optionIcon",
  "optionNo": "index-module-scss-module__uj3OjW__optionNo",
  "optionNoSelected": "index-module-scss-module__uj3OjW__optionNoSelected",
  "optionSub": "index-module-scss-module__uj3OjW__optionSub",
  "optionTitle": "index-module-scss-module__uj3OjW__optionTitle",
  "optionYes": "index-module-scss-module__uj3OjW__optionYes",
  "optionYesSelected": "index-module-scss-module__uj3OjW__optionYesSelected",
  "options": "index-module-scss-module__uj3OjW__options",
  "recommended": "index-module-scss-module__uj3OjW__recommended",
  "section": "index-module-scss-module__uj3OjW__section",
  "title": "index-module-scss-module__uj3OjW__title",
  "xIcon": "index-module-scss-module__uj3OjW__xIcon",
  "xIconSelected": "index-module-scss-module__uj3OjW__xIconSelected",
});
